// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"673ec61c","55":"2ccca303","446":"6c7671e3","453":"e0ce6ee7","794":"1bb5fe24"}[chunkId] + ".chunk.js";
};